// BrandProperties now lives under the Brands module folder — moved, not duplicated.
import BrandProperties from "../../../../components/Partners/DataIntegrations/Brands/BrandProperties/BrandProperties"

const BrandPropertiesScreen = () => {
  return (
    <>
    <BrandProperties/>
    </>
  )
}

export default BrandPropertiesScreen